import { TablePagination } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface Props {
  startIndex: (data: number) => void;
  endIndex: (data: number) => void;
  recordsCount: number;
  perPageItemCount?: number;
}

export default function AppPagination({ startIndex, endIndex, recordsCount, perPageItemCount }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(perPageItemCount ?? 10);

  useEffect(() => {
    startIndex(page);
    endIndex(rowsPerPage);
  }, []);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number,) => {
    startIndex(newPage * rowsPerPage);
    endIndex(newPage * rowsPerPage + rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    endIndex(parseInt(event.target.value, 10));
    setPage(0);
    startIndex(0);
  };

  return <> {recordsCount > 0 && <TablePagination component="div" count={recordsCount}
    page={page} onPageChange={handleChangePage}
    rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} />}
  </>
}
